import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { observer } from 'mobx-react';

@observer
class PrivateRoute extends React.PureComponent {
    render() {
        const { path, ...restProps } = this.props;
        const adminLoginName = window.localStorage.getItem('adminLoginName');

        if (adminLoginName) {
            return <Route path={path} {...restProps} />;
        }

        return <Redirect to='/admin/login' />;
    }
}

export default PrivateRoute;